import { render } from "./Tuto.vue?vue&type=template&id=08879002&scoped=true"
import script from "./Tuto.vue?vue&type=script&lang=js"
export * from "./Tuto.vue?vue&type=script&lang=js"

import "./Tuto.vue?vue&type=style&index=0&id=08879002&lang=stylus&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08879002"]])

export default __exports__